<template>
  <div class="page">
    <PaymentScreen/>
  </div>
</template>

<script>
import PaymentScreen from "@/components/point-of-sale/sales/payment/PaymenScreen";

export default {
  name: "PaymentView",
  beforeMount() {
    this.$store.commit(`generateSaleUUID`)
  },
  components: {PaymentScreen},
}
</script>

<style lang="scss" scoped>
.page {
  background: var(--bg-gradient); /* Use global background variable */
  overflow-y: auto;
  font-family: var(--font-family); /* Ensure consistent font family */
  transition: var(--transition-speed); /* Add transition for theme change */
}
</style>
